import React, { useState, useEffect } from 'react';
import { requestApi } from 'utils/request';
import SlideSection from './SlideSection';
import LoanSection from './LoanSection';
import FAQSection from './FAQSection';
import { CONTENTS_TYPE_CD } from './constants';
import { MainPageWrap } from './style';
import Layout from '../../layout';
import SellerMallSection from './MallSection';
import AizenFooter from '../../layouts/Footer/AizenFooter';
import { MobilePopup, PCPopup } from './Popup';
import dayjs from 'dayjs';
import { KEY_FO_POPUP_EXPIRED_DATE } from '../../tools/WebTool';
import { useUI } from '../../contexts/UIContext';

const { MAIN_CONTENTS } = CONTENTS_TYPE_CD;

const Main = () => {
  const { setContextLoading } = useUI();
  const [creditGoodsData, setCreditGoodsData] = useState({});
  const [uiContents, setUiContents] = useState({});
  const [isLoading, setIsLoading] = useState({ mall: true, goods: true });
  const [popupData, setPopupData] = useState(null);
  const [isPCMode, setIsPCMode] = useState(window.innerWidth >= 1200);
  const middleAreaContents = uiContents.middleArea?.find(
    data => data.exposureAreaCd === 'EAC200'
  )?.contents;

  const fetchMallLinkageInfoContents = async () => {
    try {
      const res = await requestApi({
        method: 'GET',
        url: '/v1/na/common/ui-contents/list',
        params: {
          contentsTypeCd: MAIN_CONTENTS,
        },
      });
      setUiContents(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(prev => ({ ...prev, mall: false }));
    }
  };

  const fetchCreditGoods = async () => {
    try {
      const res = await requestApi({
        method: 'GET',
        url: '/v1/na/credit-goods',
        params: {
          sortType: 'lowest_interest',
        },
      });
      setCreditGoodsData(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(prev => ({ ...prev, goods: false }));
    }
  };

  const fetchMainPopup = async () => {
    try {
      const res = await requestApi({
        method: 'GET',
        url: '/v1/na/popup',
      });

      if (!res.data?.result) {
        setPopupData(null);
        return;
      }

      setPopupData(res.data.result);
    } catch (error) {
      console.error(error);
    }
  };

  const checkIsShowingPopupByDate = () => {
    const now = dayjs();
    const expiredDate = localStorage.getItem(KEY_FO_POPUP_EXPIRED_DATE);
    return !expiredDate || now.diff(expiredDate, 'second') > 0;
  };

  useEffect(() => {
    const handleResize = () => {
      setIsPCMode(window.innerWidth >= 1200);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    (async () => {
      await Promise.all([
        fetchMainPopup(),
        fetchCreditGoods(),
        fetchMallLinkageInfoContents(),
      ]);
    })();
  }, []);

  useEffect(() => {
    if (!isLoading.goods && !isLoading.mall) setContextLoading(false);
  }, [isLoading]);

  return (
    <Layout pageTitle="main">
      <MainPageWrap className="mainPageWrap">
        {uiContents.bigBanner?.length > 0 && (
          <SlideSection bigBannerContents={uiContents.bigBanner} />
        )}
        {creditGoodsData.list?.results?.length > 0 && (
          <LoanSection creditGoodsData={creditGoodsData} />
        )}
        {!!middleAreaContents && (
          <SellerMallSection middleAreaContents={middleAreaContents} />
        )}
        <FAQSection />
        <AizenFooter />
        {popupData && checkIsShowingPopupByDate() ? (
          isPCMode ? (
            <PCPopup popupData={popupData} setPopupData={setPopupData} />
          ) : (
            <MobilePopup popupData={popupData} setPopupData={setPopupData} />
          )
        ) : null}
      </MainPageWrap>
    </Layout>
  );
};

export default Main;
